module.exports = __webpack_public_path__ + "img/anchor.462e93ed.svg";